module.exports = __webpack_public_path__ + "img/icons_list_badge.4305c2d8.svg";